import API_URL from '../apiconfig';
import axios from './api';
import { OrganizationWithBusinesses } from '../types/organizations';

export async function getOrganizationBusinesses(organizationId: string) {
  const response = await axios.get(
    `${API_URL}/v1/organizations/${organizationId}/businesses`,
  );
  return response.data.result as OrganizationWithBusinesses;
}
